<template>
  <header class="l-header">
    <div v-if="isAdmin" class="l-header__admin">
      管理者アカウントでログインしています
    </div>
    <div v-else-if="isAgency" class="l-header__admin">
      代理店アカウントでログインしています − 担当者：{{ username
      }}<template v-if="company">（{{ company }}）</template>
    </div>
    <div class="l-header__inner">
      <div v-if="!hasSide" class="l-header-logo">
        <router-link :to="{ name: 'projects' }">
          <img
            src="@/assets/img/logo-wh.svg"
            :alt="$constants.siteName"
            class="l-header-logo__image"
          />
        </router-link>
      </div>
      <div v-if="project.name" class="l-header-project">
        <p class="l-header-project__name">
          <span>{{ project.displayName }}</span>
        </p>
        <img :src="favicon" class="l-header-project__favicon" />
        <a :href="projectLinkUrl" target="_blank" class="l-header-project__url">
          {{ project.siteUrl }}
        </a>
      </div>
      <div v-if="requiresAuth && auth.isAuthenticated" class="l-header-status">
        <img
          src="@/assets/img/img-avatar.png"
          alt=""
          class="l-header-status__avatar"
        />
        <p class="l-header-status__mail">{{ email }}</p>
        <div
          class="l-header-nav"
          @click="toggleMenu"
          v-click-outside="hideMenu"
        >
          <button type="button" class="l-header-nav__btn">設定</button>
          <transition name="v-fade">
            <div v-show="isVisible" class="l-header-nav__content">
              <ul class="l-header-nav__list">
                <li v-if="!$constants.isDemo" class="l-header-nav__item">
                  <router-link :to="{ name: 'configUser' }">
                    ユーザー情報の設定・変更
                  </router-link>
                </li>
                <template v-if="organization.organizationId">
                  <li class="l-header-nav__item">
                    <router-link :to="{ name: 'configContract' }">
                      利用情報の確認
                    </router-link>
                  </li>
                  <li v-if="isAuthority" class="l-header-nav__item">
                    <router-link :to="{ name: 'configManagement' }">
                      ユーザーの管理（追加・削除）
                    </router-link>
                  </li>
                  <li v-if="projects.length" class="l-header-nav__item">
                    <Collapse class="l-block">
                      <template slot="title">
                        <span>サイトの設定・変更</span>
                        <p class="c-toggle"></p>
                      </template>
                      <template slot="content">
                        <ul class="l-header-nav__list">
                          <li
                            v-for="item in projects"
                            :key="item.id"
                            class="l-header-nav__item"
                          >
                            <router-link
                              :to="{
                                name: 'configProject',
                                params: { projectId: item.id }
                              }"
                              class="l-header-nav__link"
                            >
                              <p class="l-header-nav__name c-text--ellipsis">
                                {{ item.displayName }}
                              </p>
                            </router-link>
                          </li>
                        </ul>
                      </template>
                    </Collapse>
                  </li>
                </template>
                <li class="l-header-nav__item">
                  <Button class="logout" block @click="logout">
                    ログアウト
                  </Button>
                </li>
              </ul>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Collapse from '@/components/Collapse';
import Button from '@/components/Button';
import utils from '@/utils';

export default {
  props: ['project', 'hasSide', 'requiresAuth'],

  components: {
    Collapse,
    Button
  },
  data() {
    return {
      isVisible: false
    };
  },
  computed: {
    company() {
      return this.$store.state.user.status.company;
    },
    email() {
      return this.$store.state.user.status.email;
    },
    favicon() {
      return utils.getFavicon(this.project.siteUrl);
    },
    organization() {
      return this.$store.getters['view/organization'];
    },
    projectLinkUrl() {
      return this.project.siteUrl.replace(/^sc-domain:/, '//');
    },
    projects() {
      return this.$store.state.user.data.projects;
    },
    username() {
      return this.$store.state.user.status.username;
    },
    isAdmin() {
      return this.$store.state.user.status.isAdmin;
    },
    isAgency() {
      return this.$store.state.user.status.isAgency;
    },
    isAuthority() {
      return this.organization.isAuthority;
    }
  },
  methods: {
    logout() {
      this.auth.logout();
    },
    hideMenu() {
      this.isVisible = false;
    },
    toggleMenu() {
      this.isVisible = !this.isVisible;
    }
  }
};
</script>
